import { LegacyEventData } from '../../../types/LegacyEventData';
import { EventName, HawkEvent } from '../../entry/sendEvent';
import { BaseEvent } from '../BaseEvent';

export class LegacyEvent extends BaseEvent {
  public hawkEvent: HawkEvent;

  constructor({ data }: { data: LegacyEventData }) {
    super();

    this.hawkEvent = {
      name: EventName.HAWK_EVENT,
      data,
    };
  }
}
